type temporaryDurationType =
  | 'THREE_MONTHS'
  | 'TWELVE_MONTHS'
  | 'THIRTY_DAYS'
  | null;
export const productDurationToReadable = (
  productDuration: temporaryDurationType,
): string | null => {
  if (!productDuration) return null;
  return (
    {
      THREE_MONTHS: '3 months',
      TWELVE_MONTHS: '12 months',
      THIRTY_DAYS: '30 days',
    } as Record<Exclude<temporaryDurationType, null>, string>
  )[productDuration];
};
